// services/conversationService.js
import axios from "axios";
import { API_BASE_URL } from "../../../config";

export const getActiveConverstionList = async (conversationId, pageNumber = 1, pageSize = 10) =>
{
    try
    {
        const response = await fetch(`${API_BASE_URL}/api/Chat/ConversationMessages?conversationId=${conversationId}&pageNumber=${pageNumber}&pageSize=${pageSize}`);
        
        // 1. Check if the HTTP request was successful (e.g., status 200 OK)
        if (!response.ok) {
            // Throw an error if the server responded with a 4xx or 5xx status
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        // 2. Parse the JSON body from the response and return it
        // The .json() method returns a Promise, so we must 'await' it.
        return await response.json(); 
        
        
    } catch (error)
    {
        console.error("Error fetching getActiveConverstionList:", error);
        throw error;
    }
};
